import React from "react";
import "./TextAreaStyles.scss";

// Libraries & Packages
import { useThemeStore } from "utils/state/Store";

// Utils
import {
  setTextAreaColorStyles,
  setTextAreaDisplayStyles,
  setTextAreaFontStyles,
  setTextAreaSizeStyles,
} from "./TextAreaUtils";

function TextArea({ label, size, name, placeholder, value, onChange }) {
  // State
  const { theme } = useThemeStore();

  // TextArea Label Styles
  var stylesLabel = {
    //  Color
    color: setTextAreaColorStyles(theme).color,

    // Size
    height: setTextAreaSizeStyles(size).height,
    width: setTextAreaSizeStyles(size).width,

    // Font
    fontSize: setTextAreaFontStyles(size).fontSize,
    fontWeight: setTextAreaFontStyles().fontWeight,
    fontFamily: "Ginqail",

    // Display
    ...setTextAreaDisplayStyles(label),
  };

  //   TextArea Styles
  var stylesTextArea = {
    resize: "none",
    border: "none",
    borderRadius: "0px",
    padding: "16px",

    fontSize: "20px",
    fontFamily: "Argesta-Display",
    color: theme.palette.miscellaneous.grey.main,
    height: "300px",
  };
  return (
    <div className="wso2__ob__ui__textArea">
      <div style={stylesLabel}>{label}</div>
      <textarea
        style={stylesTextArea}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange && onChange}
      />
    </div>
  );
}

export default TextArea;
